import React, {useEffect, useState} from "react";
import moment from "moment-timezone";
import { TableCell, Typography, Link, TableRow, Tooltip, Chip} from '@mui/material';
import { useNavigate } from "react-router-dom";

const classes = {
    evenRow: {
        height: "40px",
        cursor: "pointer",
        '&:hover': {
            backgroundColor:"#d9e6f7"
         },
    },
    oddRow: {
        height: "40px",
        backgroundColor: '#f0f4f9',
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#d9e6f7"
        },
    },
    body2: {
        fontSize: "12px",
        fontWeight: '600',
        fontFamily: 'Montserrat',
        //padding: '10px'
    },
    fabButton: {
        backgroundColor: "transperent",
        color: "#DE350B"
    },
    cell: {
        padding: "10px"
    }
};

const RoleRow = (props) => {
    const { record, index } = props.value; 
    const navi = useNavigate();
    return (
    <React.Fragment>
        <TableRow sx={index%2===0?classes.evenRow:classes.oddRow} onClick={()=>navi(`/roles/details/${record?.id}`)}>
            <TableCell sx={classes.cell}>
                <Typography variant="h4">{ record.name }</Typography>
            </TableCell>
            <TableCell sx={classes.cell}>
                <Typography variant="h4" align="left">{ moment(record.createDate).tz(record.timeZone?.name || 'America/Los_Angeles').format('MMM D, YYYY') }</Typography>
            </TableCell>
            <TableCell sx={classes.cell}>
                <Typography variant="h4" color="secondary">{record.status ? 'ACTIVE' : 'INACTIVE'}</Typography>
            </TableCell>
        </TableRow>
    </React.Fragment>
);
}

export default RoleRow;